export const MAX_TITLE_LENGTH = 255;
export const DEFAULT_PRECISION = 2;
